var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._v("("+_vm._s(_vm.item.client_country_code)+") "+_vm._s(_vm.item.client_phone_number))])
}
var staticRenderFns = []

export { render, staticRenderFns }